import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { setDeviceInfo, setRfPath } from '@/redux/actions/commonActions'
import SelectLang from '@/components/selectLang'
import { formatMessageNew } from '@/utils/common'
import { getMacForPhone, deviceLogin } from '@/services/login'
import { Button, Spin } from 'antd'
import { Base64 } from '@/utils/base64'
import '@/pages/AndroidDevice/PhoneLayout.less'
import { consoleFlag } from '@/utils/default'
import VConsole from 'vconsole'
import { modalWarning, destroyModal } from '@/utils/modalUtils'
import { isExtranetHostname } from '@/utils/hostEnv'
let errorModal = null
const PhoneTagLogin = props => {
  if (consoleFlag) {
    const vConsole = new VConsole()
    console.log(vConsole)
  }
  const dispatch = useDispatch()
  const history = useHistory()
  const [loading, setLoading] = useState(true)
  const [registerStatus, setRegisterStatus] = useState(true)
  const [channels, setChannels] = useState([])
  const { channelArr } = props
  useEffect(() => {
    getMacAddress()
    window.addEventListener('keydown', onKeyDown) // 添加全局事件
    return () => {
      window.removeEventListener('keydown', onKeyDown) // 销毁
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const onKeyDown = e => {
    console.log('keyCode', e.keyCode)
    // let obj = null
    switch (e.keyCode) {
      case 13:
        if (errorModal) {
          destroyModal(errorModal)
          errorModal = null
        }
        break
      // case 112:
      //   // F1 => 112
      //   obj = channelArr.find(item => item.keyCode === 'F1')
      //   if (obj) {
      //     goHome(obj)
      //   }
      //   break
      // case 113:
      //   obj = channelArr.find(item => item.keyCode === 'F2')
      //   if (obj) {
      //     goHome(obj)
      //   }
      //   // 1025 NDDC F2 => 113
      //   break
      // case 117:
      //   // 1027 FULL F6 => 114
      //   obj = channelArr.find(item => item.keyCode === 'F6')
      //   if (obj) {
      //     goHome(obj)
      //   }
      //   break
      // case 118:
      //   // 1027 NDDC F7 => 115
      //   obj = channelArr.find(item => item.keyCode === 'F7')
      //   if (obj) {
      //     goHome(obj)
      //   }
      //   break
      default:
        break
    }
  }

  const saveMacAddress = (macAddress, dt = {}) => {
    const macString = Base64.encode(JSON.stringify(macAddress || ''))
    const deviceCodeString = Base64.encode(JSON.stringify(dt.deviceCode || ''))
    const functionModuleString = Base64.encode(JSON.stringify(dt.functionModule || ''))
    localStorage.setItem('mac', macString)
    localStorage.setItem('deviceCode', deviceCodeString)
    localStorage.setItem('functionModule', functionModuleString)
    const infoCommon = {
      mac: JSON.stringify(macAddress),
      deviceCode: JSON.stringify(dt.deviceCode),
      functionModule: JSON.stringify(dt.functionModule)
    }
    dispatch(setDeviceInfo(infoCommon))
  }

  const getMacAddress = () => {
    getMacForPhone({})
      .then(res => {
        login(res.resultData)
      })
      .catch(err => {
        setLoading(false)
        // 未获取到mac地址 报错
        console.log('macAddress err-首页', err)
        errorModal = modalWarning({
          content: formatMessageNew('languageObj.nsptagLocale.rfMacError')
        })
      })
  }

  const login = macAddress => {
    deviceLogin(macAddress)
      .then(res => {
        setLoading(false)
        const dt = res.resultData
        if (dt.status !== 'Enabled') {
          setRegisterStatus(false)
          return
        }
        const channelList = dt.functionModule ? dt.functionModule.split(',') : []
        let list = channelArr.filter(item => channelList.includes(item.type) || !item.type)
        if (isExtranetHostname()) {
          list = list.filter(item => item.router !== '/qr/rfIdScan')
        } else {
          if (list.find(item => item.router === '/qr/rfIdScan')) {
            list = list.filter(item => item.router !== '/rf/reprint/print')
          }
        }
        setChannels(list)
        saveMacAddress(macAddress, dt)
      })
      .catch(err => {
        setLoading(false)
        setRegisterStatus(true)
        const list = channelArr.filter(item => !item.type)
        setChannels(list)
        saveMacAddress(macAddress)
        // if (err.errorCode === '2105') {
        //   setRegisterStatus(false)
        // }
      })
  }

  const goHome = item => {
    localStorage.setItem('rfPathtest', item.value)
    const rfPathString = Base64.encode(JSON.stringify(item.value || ''))
    localStorage.setItem('rfPath', rfPathString)
    if (item.plant) {
      localStorage.setItem('rfPlant', item.plant)
    }
    dispatch(setRfPath({ rfPath: JSON.stringify(item.value) }))
    if (item.router === '/qr/rfIdScan') {
      const rfidScanContext = {
        // 旧逻辑保留：
        // labelCode: item.labelCode,
        // plant: item.plant,
        // businessType: item.businessType
        labelCode: item.labelCode,
        plant: item.plant,
        businessType: item.businessType,
        roundPower: item.roundPower,
        normalPower: item.normalPower
      }
      localStorage.setItem('rfidScanContext', Base64.encode(JSON.stringify(rfidScanContext)))
      history.push({
        pathname: item.router,
        state: rfidScanContext
      })
    } else {
      history.push({
        pathname: item.router
      })
    }
  }

  return (
    <Spin spinning={loading} size="large" style={{ top: '50vh', transform: 'translateY(-50%)', zIndex: 10000 }}>
      <div className="login-wrapper">
        <div className="login-header">
          <div className="login-form-logo">
            <span className="nsg-glyph--swoosh" />
          </div>
          <SelectLang />
        </div>
        <div className="login-content">
          <div className="login-title">{formatMessageNew('languageObj.loginLocale.loginTitle')}</div>
          {!registerStatus && (
            <div className="login-error-message">
              <p className="error-title">{formatMessageNew('languageObj.loginLocale.deviceNotRegisteredTitle')}</p>
              <p className="error-content">{formatMessageNew('languageObj.loginLocale.deviceNotRegisteredContent')}</p>
            </div>
          )}
          {registerStatus && channels.length <= 0 && (
            <div>{formatMessageNew('languageObj.loginLocale.noChannelInfo')}</div>
          )}
          {registerStatus && channels.length > 0 && (
            <div className="login-list">
              {channels.map((item, idx) => (
                <Button size="large" key={idx} className="phone-btn login-btn" onClick={() => goHome(item)}>
                  {item.labelType === 'function' ? item.label() : item.label}
                </Button>
              ))}
            </div>
          )}
          {/* {registerStatus && channels.length > 0 && (
            <div className="login-tip">{formatMessageNew('languageObj.loginLocale.shortcutKey')}</div>
          )} */}
        </div>
      </div>
    </Spin>
  )
}
export default PhoneTagLogin
